export const paddingKeys = ['p', 'pt', 'pb', 'pl', 'pr', 'px', 'py'];
